<template>
  <div class="login">
   <Title titleName='新增规则' iconLeft="back"/>

	<div class="login_user">
		<div class="user_link">
			
		<div class="lab">市场价</div> <input v-model="reg.market_left" placeholder="报价左区间" /><span>-</span>  <input v-model="reg.market_right" placeholder="报价右区间" />
		</div>
		<div class="user_input">
			
		<div class="lab">包含影院</div> <input v-model="reg.contain_cinema" placeholder="请输入包含影院名称" />
		</div>
		<div class="user_input">
			
		<div class="lab">不包含影院</div> <input v-model="reg.un_contain_cinema" placeholder="请输入不包含影院名称" />
		</div>
	<div class="user_input">
		
	<div class="lab">包含影片</div> <input v-model="reg.contain_movie" placeholder="请输入包含影片名称" />
	</div>
	<div class="user_input">
		
	<div class="lab">不包含影片</div> <input v-model="reg.un_contain_movie" placeholder="请输入不包含影片名称" />
	</div>
<div class="user_input">
		
	<div class="lab">包含影厅</div> <input v-model="reg.contain_hall" placeholder="请输入包含影厅名称" />
	</div>
	<div class="user_input">
			
		<div class="lab">不包含影厅</div> <input v-model="reg.un_contain_hall" placeholder="请输入不包含影厅名称" />
		</div>

	
		
	</div>
	<div class="login_user">
			<van-field name="radio" label="情侣座">
			  <template #input>
			    <van-radio-group v-model="reg.lovers_seat" direction="horizontal" checked-color="#FF5E00">
			      <van-radio :name="1">可含情侣座</van-radio>
			      <van-radio :name="0">不含情侣座</van-radio>
			    </van-radio-group>
			  </template>
			</van-field>
			<van-field name="radio" label="接受调座">
			  <template #input>
			    <van-radio-group v-model="reg.accept_seats" direction="horizontal" checked-color="#FF5E00">
			      <van-radio :name="1">含不可调座</van-radio>
			      <van-radio :name="0">只含调座</van-radio>
			    </van-radio-group>
			  </template>
			</van-field>
			<van-field name="radio" label="座位数量">
			  <template #input>
			    <van-radio-group v-model="reg.seats_number" direction="horizontal" checked-color="#FF5E00">
			      <van-radio :name="0">不限</van-radio>
			      <van-radio :name="1">单数</van-radio>
				  <van-radio :name="2">双数</van-radio>
			    </van-radio-group>
			  </template>
			</van-field>
		<van-field name="radio" label="报价模式">
		  <template #input>
		    <van-radio-group v-model="reg.offer_type"  checked-color="#FF5E00">
		      <van-radio class="look" :name="1">比例报价</van-radio>
		
		      <van-radio class="look" :name="3">最高价减法报价</van-radio>
			  <van-radio class="look" :name="4">固定金额报价</van-radio>
			 <div class="user_half">
			 	
			 <input v-model="reg.offer_value" placeholder="按市场价的比例" />%
			 </div>
		    </van-radio-group>
			
		  </template>
		 
		</van-field>
		
		<van-field name="radio" label="状态">
		  <template #input>
		    <van-radio-group v-model="reg.state" direction="horizontal" checked-color="#FF5E00">
		      <van-radio :name="1">启用</van-radio>
		      <van-radio :name="0">禁用</van-radio>
			 
		    </van-radio-group>
		  </template>
		</van-field>
		
		</div>
	<div class="login_bt">
		<van-button @click="submitForm()" round color="#FF5E00" block>保存</van-button>
	</div>
		



	<van-popup v-model="showPicker" position="bottom">
		<van-area title="标题" :area-list="areaList" @confirm="onConfirm"  @cancel="showPicker = false"/>
	
</van-popup> 

	
  </div>
</template>
<script>
import Title from "@/common/title";
import { Toast } from 'vant';	
export default {
  components: {
    Title,

  },
  data() {
    return {
		reg: {
			id:'',
			market_left:'',
			market_right:'',
			contain_cinema:'',
			un_contain_cinema:'',
			contain_movie:'',
			un_contain_movie:'',
			contain_hall:'',
			un_contain_hall:'',
			lovers_seat:1,
			accept_seats:1,
			seats_number:0,
			offer_type:1,
			offer_value:'',
			state:1
			         
		      },
    
    };
  },mounted() {
	  
	if(this.$route.query.id){
		this.reg.id = this.$route.query.id
		this.funder()
	}
	  
  	
	this.sandMate()
	this.sandCase()
  },methods:{
	   onConfirm(value) {
		  
	       this.reg.areaName = value[0].name+'-'+value[1].name+'-'+value[2].name;
		   this.reg.area_id=value[2].code
		   this.reg.province_name=value[0].name
		   this.reg.city_name=value[1].name
		   this.reg.area_name=value[2].name
	       this.showPicker = false;
	      },
	  submitForm() {
	  				
	  			
	          this.$axios({
	            method: "post",
	            url: "stores/offer_rule",
	            data: this.reg,  
	          }).then((res) => {
	          	let data=res.data;
	          			
	          	if(data.code==200){
	  						
	  			  Toast(data.message);
				  this.$router.back()
	    
	          		
	          	}else{  
	  				Toast(data.message);
	  						      
	  					}
	           
	          });
	  				 
	  		
	       
	       },funder(){
			   this.$axios.get('stores/rule_list',{params:{
				   rule_id:this.reg.id
			   }}).then((res)=>{
				   let data=res.data;
				   if(data.code==200){
					   this.reg=data.data
					   
				   }
			   })
			   

			  				 
	}
	
  }
};
</script>
<style lang="scss" scoped>

.login{
	width: 100%;
	height: 100%;
	
	.logo{
		width: 266px;
		height: 156px;
		margin: 150px;
	}
	
	.login-button {
	  background: #F8F8F8;
	
	  .han{
		  background: #6DAD19;
	  }
	 
	}
	
	.login_user{
		width: 100%;
		height: auto;
		display: flex;
		flex-direction: column;
		background: #FFFFFF;
		align-items: center;
		justify-content: flex-start;
		margin-top: 20px;
		.look{
			margin-bottom: 20px;
		}
	}
.login_bt{
		
		width: 631px;
		margin: 50px auto;
		margin-bottom: 200px;
	}
	.login_at{
			display: flex;
			width: 631px;
			margin: 50px auto;
			justify-content: space-between;
		
		}
	.login_user .user_input{
		width: 700px;
		color: #000000;
		font-size: 28px;
		height: 100px;
		border-bottom: 1px solid #eee;
		display: flex;
		margin-left: 20px;
		flex-direction: row;
		align-items: center;
		justify-content: flex-start;

		.lab{
			width: 200px;
		}
		span{
			color: #E72E34;
			margin-left: 10px;
			
		}
		.ip{
			width: 30px;
			img{
				width: 100%;
			}
		}
	
	}
	.login_user .user_input .input_icon{
		width: 39px;
		height: 46px;
		margin-right: 22px;
		margin-left: 16px;
	}
	.login_user .user_input input{
		flex: 1;
		height: 46px;
		font-size: 22px;
		color: #6d6d6d;
		background:none;  
		outline:none;  
		border:none;
	}
	.login_user .user_input input:focus{  
		border:none;
	}
	.login_user .user_link{
		width: 700px;
		color: #000000;
		font-size: 28px;
		height: 100px;
		border-bottom: 1px solid #eee;
		display: flex;
		margin-left: 20px;
		flex-direction: row;
		align-items: center;
		justify-content: flex-start;
	
		.lab{
			width: 200px;
		}
		input{
			border: 1px solid #dddddd;
			width: 190px;
			height: 80px;
			padding-left: 20px;
		}
		span{
			margin: 0 10px;
			
		}
		.ip{
			width: 30px;
			img{
				width: 100%;
			}
		}
	
	}
	.login_user .user_half{
		width: 800px;
		color: #000000;
		font-size: 28px;
		height: 100px;
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: flex-start;
	
	
		input{
			border: 1px solid #dddddd;
			width: 250px;
			height: 80px;
			padding-left: 20px;
			margin-right: 20px;
		}
	
	
	}
	.login_user .user_input .show_pwd_icon{
		width: 32px;
		height: 20px;
		cursor: pointer;
		margin-left: 65px
	}
}

 .pro-tit{
	 background: #FFFFFF;
	 text-align: center;
	 line-height: 40px;
	 padding: 20px 0;
	 h3{
		 font-size: 36px;
	 }
	 p{
		 font-size: 24px;
	 }
 }
</style>